import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ReliefService } from 'src/app/services/relief.service';
import { Relief } from '../../shared/models/relief';
import * as CryptoJS from 'crypto-js'; 
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-daily',
  templateUrl: './daily.component.html',
  styleUrls: ['./daily.component.css']
})
export class DailyComponent implements OnInit {
  // Variables de environment
  isBeta = environment.beta;
  isProduction = environment.production;
  version = environment.version;

  fecha: string;
  user: any = '';
  fraseRandom: string;
  color: string;
  reliefForm = new UntypedFormGroup({
    relief: new UntypedFormControl(''),
    deleteIn24h: new UntypedFormControl(false) // Agregar este campo
  });
  // feelings:string[] = ['😃 Feliz','🙂 Contento','😐 Serio','🫤 Incomodo','😞 Triste','😤 Enojado'];
  feelings = [
    { name: 'Feliz', emoji: '😃', color: 'bg-teal-200' },
    { name: 'Contento', emoji: '🙂', color: 'bg-green-200' },
    { name: 'Serio', emoji: '😐', color: 'bg-amber-100' },
    { name: 'Incomodo', emoji: '🫤', color: 'bg-orange-200' },
    { name: 'Triste', emoji: '😞', color: 'bg-blue-200' },
    { name: 'Enojado', emoji: '😤', color: 'bg-red-200' }
  ];
  feelingSelected:string;
  showModal: boolean = false; // Controla la visibilidad de la modal
  modalMessage: string = '';  // Mensaje que se mostrará en la modal
  showDropdown: boolean = false;

  // Método para abrir la modal con un mensaje
  openModal(message: string): void {
    this.modalMessage = message;
    this.showModal = true;
  }

  // Método para cerrar la modal
  closeModal(): void {
    this.showModal = false;
  }
  constructor(
    private _reliefService: ReliefService,
    private _authService: AuthService,
    private router: Router
  ) { 
    let date2 = new Date().toDateString();
    console.log(date2);
    this.fecha = ` ${date2}`;
    // frase Random
    this.fraseRandom = '';
    this.feelingSelected = '';
    this.color = '';
    const frases = ['Deshazte de esos pensamientos que te aquejan...', '¿Cómo va tu día?', 'Sientete libre de escribir, este es tu espacio...', '¿Te pasó algo interesante el día de hoy?', 'Un lugar seguro para tus pensamientos']
    this.fraseRandom += frases[Math.floor(Math.random() * frases.length)];
  }

  ngOnInit(): void {
    this.user = this._authService.currentUser?.uid ?? '';
  }

  newDaily() { 
    // Validar que el campo de texto no esté vacío
    const reliefText = this.reliefForm.get('relief')?.value?.trim();
    if (!reliefText) {
      this.openModal('El campo de texto no puede estar vacío.');
      return;
    }

    // Validar que se haya seleccionado un sentimiento
    if (!this.feelingSelected) {
      this.openModal('Elige un sentimiento con el que te sientas identificado.');
      return;
    }

    // Verificar el valor del checkbox de forma más específica
    const deleteIn24hControl = this.reliefForm.get('deleteIn24h');
    const deleteIn24h = deleteIn24hControl ? deleteIn24hControl.value : false;
  

    // Convertir explícitamente a boolean
    const shouldDelete = Boolean(deleteIn24h);

    // Asignar color basado en el sentimiento seleccionado
    const feelingColors: { [key: string]: string } = {
      'Feliz': 'bg-teal-200',
      'Contento': 'bg-green-200',
      'Serio': 'bg-amber-100',
      'Incomodo': 'bg-orange-200',
      'Triste': 'bg-blue-200',
      'Enojado': 'bg-red-200'
    };
    this.color = feelingColors[this.feelingSelected] || 'bg-gray-200';

    // Crear el objeto Relief con la nueva funcionalidad
    const relief: Relief = {
      userId: this.user,
      color: this.color,
      relief: CryptoJS.AES.encrypt(JSON.stringify(reliefText), this.user).toString(),
      feeling: this.feelingSelected,
      createdAt: new Date(),
      updatedAt: new Date(),
      // Nuevos campos para eliminación en 1 minuto
      deleteIn24h: shouldDelete,
      // deleteAt: shouldDelete ? new Date(Date.now() + 1 * 60 * 1000) : null
      deleteAt: shouldDelete ? new Date(Date.now() + 24 * 60 * 60 * 1000) : null

    };
    
    
    // Enviar el objeto al servicio
    this._reliefService.newRelief(relief);
    
    // Limpiar el formulario después de enviar
    this.reliefForm.patchValue({
      relief: '',
      deleteIn24h: false
    });
    this.feelingSelected = '';
    this.color = '';
    
    // Redirigir a la página de inicio
    this.router.navigate(['/home']);
  }

  getBackgroundColor(tailwindClass: string): string {
    const colorMap: { [key: string]: string } = {
      'bg-teal-200': '#99f6e4',
      'bg-green-200': '#bbf7d0',
      'bg-amber-200': '#fde68a',      // Cambiar de bg-yellow-200 a bg-amber-200
      'bg-orange-200': '#fed7aa',
      'bg-rose-200': '#fecdd3',
      'bg-red-200': '#ffb5b5ff'
    };
    return colorMap[tailwindClass] || '#f3f4f6';
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  selectFeeling(feeling: string) {
    this.feelingSelected = feeling;
    this.showDropdown = false;
  }

  getFeelingEmoji(feelingName: string): string {
    const feeling = this.feelings.find(f => f.name === feelingName);
    return feeling ? feeling.emoji : '';
  }

  getSelectedFeelingColor(): string {
    if (!this.feelingSelected) {
      return 'bg-gradient-to-l from-indigo-300 to-purple-300 dark:bg-slate-500 text-indigo-900';
    }
    
    const selectedFeeling = this.feelings.find(f => f.name === this.feelingSelected);
    if (selectedFeeling) {
      // Retorna la clase de color con texto más oscuro para contraste
      const colorClasses = {
        'bg-teal-200': 'bg-teal-200 text-teal-800 dark:text-teal-900',
        'bg-green-200': 'bg-green-200 text-green-800 dark:text-green-900',
        'bg-amber-200': 'bg-amber-200 text-amber-800 dark:text-amber-900',
        'bg-orange-200': 'bg-orange-200 text-orange-800 dark:text-orange-900',
        'bg-rose-200': 'bg-rose-200 text-rose-800 dark:text-rose-900',
        'bg-red-200': 'bg-red-200 text-red-800 dark:text-red-900'
      };
      return colorClasses[selectedFeeling.color as keyof typeof colorClasses] || 'bg-gray-200 text-gray-800';
    }
    
    return 'bg-gradient-to-l from-indigo-300 to-purple-300 dark:bg-slate-500 text-indigo-900';
  }

}
